import * as React from "react";
import { HTMLProps } from "react";
import styled from "styled-components";

const Container = styled.div`
  position: relative;
`;

const BGImage = styled.img`
  width: 100%;
  min-width: 100%;
  height: 100%;
  min-height: 100%;
`;

const FGImage = styled(BGImage)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

const FGImageHover = styled(FGImage)`
  opacity: 0;
  transition: opacity 0.05s ease;

  ${Container}:hover & {
    opacity: 1;
  }
`;

interface Props {
  sources: Array<HTMLProps<HTMLImageElement>["src"]>;
  alt: HTMLProps<HTMLImageElement>["alt"];
}

export const Hover = ({ sources, alt }: Props) => (
  <Container>
    {sources.map((src, i) => {
      switch (i) {
        case 0:
          return <BGImage key={i} src={src} alt={alt} />;
        case 1:
          return <FGImageHover key={i} src={src} alt="" />;
        default:
          return <FGImage key={i} src={src} alt="" />;
      }
    })}
  </Container>
);
